function updateCartCountClass() {
  const cartCountElement = document.querySelector('hdt-cart-count.hdt-count-box.hdt-absolute');
  
  if (cartCountElement) {
    const count = parseInt(cartCountElement.textContent) || 0;
    const hasActiveClass = cartCountElement.classList.contains('cart-count-active');
    
    if (count > 0 && !hasActiveClass) {
      cartCountElement.classList.add('cart-count-active');
    } else if (count === 0 && hasActiveClass) {
      cartCountElement.classList.remove('cart-count-active');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  updateCartCountClass();
  
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const target = mutation.target;
        
        if (target.closest && (
          target.closest('hdt-cart-count') || 
          target.closest('.hdt-site-nav_cart') ||
          target.closest('.cart-count-bubble')
        )) {
          shouldUpdate = true;
        }
      }
    });
    
    if (shouldUpdate) {
      setTimeout(updateCartCountClass, 50);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
  
});
